import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ConnectedFaresTrackingCalculator } from '../../../components/Calendar/Context/FaresTrackingCalculator';
import { SearchButtonStyled } from '../../SearchButton';
import { ABUtils, CMS } from '../../../utils';
import { TripType, TripTypeProp } from '../../../models';
import { SlideGroupContext } from '../../../components/SlideManager';
import { isTrainsProductActive } from '../../../redux/currentSearch/selectors';

export const ButtonCTA = ({
    isHotelOptionEnabled,
    isSearchFragmentPage,
    tripType,
    buttonWrapperClassNames,
    secondaryButtonClassNames,
    position,
}) => {
    const { isAbTrain, isStreamSearch, isReduceSearchFlow } = ABUtils.getABs();
    const slideGroupContext = useContext(SlideGroupContext);
    const flightsSearchEventId = isStreamSearch ? 'flights-search-streaming' : 'flights-search';
    const hasSecondaryCTA = isHotelOptionEnabled && TripType.ROUND_TRIP === tripType;
    const isTrainsProduct = useSelector((state) => isTrainsProductActive(state));

    const onSearchErrorCallback = () => {
        if (isReduceSearchFlow && isSearchFragmentPage) {
            slideGroupContext.close();
        }
    };
    return (
        <React.Fragment>
            <div className={buttonWrapperClassNames}>
                <ConnectedFaresTrackingCalculator>
                    {({ extraTracking }) => (
                        <SearchButtonStyled
                            block
                            extraTracking={extraTracking}
                            testId={`search-flights-${position}btn`}
                            htmlEventID={flightsSearchEventId}
                            onErrorCallback={onSearchErrorCallback}
                        >
                            { (isAbTrain || isTrainsProduct) ?
                                <CMS id="flightsManager.search.TRAINS" /> : <CMS id="flightsManager.search.main" /> }
                        </SearchButtonStyled>
                    )}
                </ConnectedFaresTrackingCalculator>
                {hasSecondaryCTA && (
                    <div className={secondaryButtonClassNames}>
                        <SearchButtonStyled
                            block
                            dynPack
                            version="secondary"
                            testId={`search-dp-${position}btn`}
                            onErrorCallback={onSearchErrorCallback}
                        >
                            { isAbTrain ? <CMS id="flightsManager.searchDynpack.TRAINS" /> :
                                <CMS id="flightsManager.searchDynpack.main" /> }
                        </SearchButtonStyled>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

ButtonCTA.propTypes = {
    isHotelOptionEnabled: PropTypes.bool,
    isSearchFragmentPage: PropTypes.bool,
    tripType: TripTypeProp,
    buttonWrapperClassNames: PropTypes.string,
    secondaryButtonClassNames: PropTypes.string,
    position: PropTypes.string,
};

ButtonCTA.defaultProps = {
    isHotelOptionEnabled: true,
    isSearchFragmentPage: false,
    tripType: TripType.ROUND_TRIP,
    buttonWrapperClassNames: '',
    secondaryButtonClassNames: '',
    position: '',
};
